export default __webpack_public_path__ + "static/media/square-poster.fe3cd9cd.png";